import { ViewFactory } from 'src/3rds/cube-react'

import { CadastroLoteScope } from '../CadastroLote.scopes'
import CadastroLoteView from './CadastroLote.view'

export { CadastroLoteView } from './CadastroLote.view'

export function registerViews(rv = ViewFactory.register) {
    rv(CadastroLoteScope, CadastroLoteView)
}
